import { AboutRow } from './aboutRow';

export class CustomPageData {
  name?: string = 'New Page';
  title?: string;
  html = '';
  isCustomPage?: boolean;
  createdOn?: string;
  updatedOn?: string;
  dropdownKey?: string;
  isNoDropdown?: boolean;
  isLandingPage?: boolean;
  isLocationSpecific?: boolean;
  locationKeys?: string[];
  metaTitle?: string;
  metaImage?: string;
  metaImageAlt?: string;
  metaDescription?: string;

  isRows?: boolean;
  rows?: AboutRow[];
  hideTitle?: boolean;
  showHero?: boolean;
  background?: string;

  // for navbar
  external?: boolean;
  isDropDown?: boolean;
  route?: string;
  topLevel?: boolean;
  key?: string;
  $key?: string;
  navbarContent?: string;

  constructor() {
    this.createdOn = new Date().toString();
    this.isCustomPage = true;
    this.external = false;
    this.isDropDown = false;
    this.topLevel = false;
    this.isRows = false;
    this.hideTitle = false;
    this.rows = [];
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/customPageData.ts